"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _DebounceHook = _interopRequireDefault(require("../DebounceHook"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const BrixelSwitchButton = props => {
  const {
    className = '',
    disableDelay = true,
    disabled = false,
    input,
    isReversed = false,
    label,
    labelHtml
  } = props;
  // STATE
  const convertedValue = Boolean(input.value);
  const [currentValue, setCurrentValue] = (0, _react.useState)(input.value);
  const [posx, setPosX] = (0, _react.useState)(0);
  const [checked, setChecked] = (0, _react.useState)(convertedValue || false);
  const spanEl = (0, _react.useRef)(null);
  const labelEl = (0, _react.useRef)(null);
  const debouncedSearchTerm = (0, _DebounceHook.default)(currentValue, disableDelay ? 0 : 500);
  (0, _react.useEffect)(() => {
    setCurrentValue(input.value);
    if (labelEl.current && spanEl.current) {
      const lbl = labelEl.current;
      const spn = spanEl.current;
      const maxRightPos = lbl.offsetWidth - spn.offsetWidth - 4;
      if (input.value) setPosX(maxRightPos);else setPosX(0);
      setChecked(convertedValue);
    }
  }, [input.value]);
  (0, _react.useEffect)(() => {
    if (checked && spanEl.current) {
      const spn = spanEl.current;
      setPosX(spn.offsetWidth);
    }
  }, [spanEl, checked]);
  (0, _react.useEffect)(() => {
    if (input.onChange && !disabled && !disableDelay) {
      input.onChange(checked);
    }
  }, [debouncedSearchTerm]);
  (0, _react.useEffect)(() => {
    if (input.onChange && !disabled && disableDelay && (typeof input.value === 'undefined' || input.value !== checked)) {
      input.onChange(checked);
    }
  }, [checked]);
  const dragel = e => {
    if (disabled) return false;
    if (labelEl.current && spanEl.current) {
      const lbl = labelEl.current;
      const spn = labelEl.current;
      const realPos = e.screenX - spn.offsetWidth - lbl.getBoundingClientRect().left;
      const maxRightPos = lbl.offsetWidth - spn.offsetWidth - 4;
      if (realPos >= 0 && realPos <= maxRightPos) {
        setPosX(realPos);
      }
      if (e.pageX !== 0) {
        if (realPos > 8) setChecked(true);else setChecked(false);
      }
    }
    return null;
  };
  const clickEl = e => {
    if (disabled) return false;
    if (e) e.preventDefault();
    if (labelEl.current && spanEl.current) {
      const lbl = labelEl.current;
      const spn = labelEl.current;
      const maxRightPos = lbl.offsetWidth - spn.offsetWidth - 4;
      if (checked) setPosX(0);else setPosX(maxRightPos);
      setChecked(!checked);
    }
    return null;
  };
  const dragEnd = () => {
    if (disabled) return false;
    if (labelEl.current && spanEl.current) {
      const lbl = labelEl.current;
      const spn = labelEl.current;
      const maxRightPos = lbl.offsetWidth - spn.offsetWidth - 4;
      if (posx > 8) {
        setChecked(true);
        setPosX(maxRightPos);
      } else {
        setChecked(false);
        setPosX(0);
      }
    }
    return null;
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: `brixel-switch-button labelText ${checked ? 'checked' : ''} ${disabled ? 'disabled' : ''} ${className} ${isReversed ? 'dis-fl-row-rev jc-b' : ''}`
  }, /*#__PURE__*/_react.default.createElement("input", {
    role: "switch",
    className: "react-switch-checkbox notranslate pos-a",
    id: "react-switch-new",
    type: "checkbox",
    checked: checked,
    disabled: disabled,
    onChange: e => clickEl(e)
  }), /*#__PURE__*/_react.default.createElement("label", {
    className: "react-switch-label notranslate",
    htmlFor: "react-switch-new",
    ref: labelEl,
    onClick: e => clickEl(e)
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "react-switch-button",
    style: {
      transform: `translate(${posx}px, 0)`
    },
    ref: spanEl
  }), /*#__PURE__*/_react.default.createElement("span", {
    draggable: true,
    onDragEnd: () => dragEnd(),
    onDragOver: e => e.preventDefault(),
    className: "react-switch-button-move",
    onDrag: e => dragel(e)
  })), labelHtml && (/*#__PURE__*/_react.default.createElement("div", {
    className: "labelTextHtml",
    dangerouslySetInnerHTML: {
      __html: labelHtml
    }
  })), label && (/*#__PURE__*/_react.default.createElement("span", {
    className: "labelText"
  }, label)));
};
var _default = exports.default = BrixelSwitchButton;